"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[61060],{

/***/ 566783:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "R": function() { return /* binding */ useBuildPcProducts; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(891987);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(643015);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(927890);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39486);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(534090);
/* harmony import */ var _teko_discovery_v2__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(232771);
/* harmony import */ var hooks_useHandlerUnderEighteenYearOld__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(725530);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(634655);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(788813);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(360339);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







const useBuildPcProducts = (params, onCloseModal, categoryName)=>{
    const { discoveryServiceV2 , discoveryHelper  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useServices */ .Su)();
    const { isDisplayUom , showNewProductGift  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { frames  } = (0,contexts__WEBPACK_IMPORTED_MODULE_3__/* .useFrame */ .x)();
    const { transformProductWhenUserUnder18  } = (0,hooks_useHandlerUnderEighteenYearOld__WEBPACK_IMPORTED_MODULE_4__/* .useHandlerUnderEighteenYearOld */ .x)();
    const { addHardware  } = (0,contexts__WEBPACK_IMPORTED_MODULE_5__/* .useBuildPCV2 */ .s)();
    const cartV2 = (0,contexts__WEBPACK_IMPORTED_MODULE_6__/* .useCartV2 */ .T6)();
    const _ref = (0,_teko_discovery_v2__WEBPACK_IMPORTED_MODULE_7__/* .useDiscoverySearchV2 */ .t)(discoveryServiceV2, _objectSpreadProps(_objectSpread({}, params), {
        isNeedFeaturedProducts: false
    }), {
        transform: (data)=>{
            var ref;
            return {
                products: (ref = data.products) === null || ref === void 0 ? void 0 : ref.map((product)=>discoveryHelper.cleanupDiscoveryV2SearchProduct(product, {
                        showUom: isDisplayUom,
                        frames,
                        showNewProductGift,
                        cartV2
                    })),
                filter: data.filter,
                pagination: {
                    totalItems: data.total,
                    totalPages: Math.ceil(data.total / constants_index__WEBPACK_IMPORTED_MODULE_8__/* .BUILD_PC_MODAL_PAGE_SIZE */ .aJ)
                }
            };
        }
    }), { result  } = _ref, rest = _objectWithoutProperties(_ref, [
        "result"
    ]);
    const productList = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        return ((result === null || result === void 0 ? void 0 : result.products) || []).map((p)=>_objectSpreadProps(_objectSpread({}, p), {
                ctaButton: !p.contactButton ? _objectSpread({
                    children: (0,i18n__WEBPACK_IMPORTED_MODULE_9__.t)("Chọn"),
                    variant: "secondary"
                }, (0,helpers__WEBPACK_IMPORTED_MODULE_10__/* .isServerless */ .ep)() ? {
                    onClick: (e)=>{
                        e.preventDefault();
                        addHardware(categoryName, {
                            sku: p.sku,
                            quantity: 1
                        });
                        onCloseModal();
                    }
                } : {}) : undefined
            })).map(transformProductWhenUserUnder18);
    }, [
        JSON.stringify(result === null || result === void 0 ? void 0 : result.products),
        transformProductWhenUserUnder18,
        categoryName, 
    ]);
    return _objectSpread({
        products: productList,
        filter: result === null || result === void 0 ? void 0 : result.filter,
        pagination: result === null || result === void 0 ? void 0 : result.pagination
    }, rest);
};


/***/ }),

/***/ 25254:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ HamperCard; },
/* harmony export */   "v": function() { return /* binding */ EHamperCardType; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(561261);
/* harmony import */ var _teko_auth_react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(983546);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(387100);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(806748);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(386877);
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(280392);
/* harmony import */ var _teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(922859);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(626650);
/* harmony import */ var contexts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(684443);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(41796);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(634655);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}







var EHamperCardType;
(function(EHamperCardType) {
    EHamperCardType["HAMPER"] = "hamper";
    EHamperCardType["HAMPER_ITEM"] = "hamperItem";
})(EHamperCardType || (EHamperCardType = {}));
const HamperCard = (props)=>{
    var ref, ref1, ref2, ref3;
    const { hamperItemKey ="" , hamperCardType =EHamperCardType.HAMPER , setShowPopupCheckAge  } = props, rest = _objectWithoutProperties(props, [
        "hamperItemKey",
        "hamperCardType",
        "setShowPopupCheckAge"
    ]);
    const { hamperData , addHamper , minusHamper , removeHamper , onUpdateConfig , removeHamperItem , setHamperItemQuantity , onChangeQuantityHamper , increaseHamperItemQuantity , decreaseHamperItemQuantity ,  } = (0,contexts__WEBPACK_IMPORTED_MODULE_1__/* .useHamper */ .h)();
    const { isMobile  } = (0,contexts__WEBPACK_IMPORTED_MODULE_2__/* .useTenantConfig */ .Wx)();
    const { user , loading: authLoading  } = (0,_teko_auth_react__WEBPACK_IMPORTED_MODULE_3__/* .useAuth */ .aC)();
    const hamperQuantity = ((ref1 = hamperData === null || hamperData === void 0 ? void 0 : (ref = hamperData.hampers) === null || ref === void 0 ? void 0 : ref.find((h)=>h.sku === props.sku)) === null || ref1 === void 0 ? void 0 : ref1.quantity) || 0;
    const hamperItemQty = ((ref3 = (ref2 = hamperData.configs[hamperData.activeIndex][hamperItemKey]) === null || ref2 === void 0 ? void 0 : ref2.find((h)=>h.sku === props.sku)) === null || ref3 === void 0 ? void 0 : ref3.quantity) || 0;
    const quantity = hamperCardType === EHamperCardType.HAMPER ? hamperQuantity : hamperItemQty;
    const handleAdd = (sku)=>{
        if (authLoading) return;
        const isUnder18 = (0,helpers__WEBPACK_IMPORTED_MODULE_4__/* .requiredConfirm18YearsOld */ .bO)(user) && !!(rest === null || rest === void 0 ? void 0 : rest.isAlcoholicCategory);
        const onAddHamper = ()=>{
            if (hamperCardType === EHamperCardType.HAMPER) {
                addHamper(sku);
            } else {
                increaseHamperItemQuantity(hamperItemKey, sku);
            }
        };
        if (isUnder18 && setShowPopupCheckAge) {
            setShowPopupCheckAge(true);
        } else onAddHamper();
    };
    const handleMinus = (sku)=>{
        if (hamperCardType === EHamperCardType.HAMPER) {
            minusHamper(sku);
        } else {
            decreaseHamperItemQuantity(hamperItemKey, sku);
        }
    };
    const handleRemove = (sku)=>{
        if (hamperCardType === EHamperCardType.HAMPER) {
            removeHamper(sku);
        } else {
            removeHamperItem(hamperItemKey, sku);
        }
    };
    const handleChangeQuantity = (sku, quantity)=>{
        if (hamperCardType === EHamperCardType.HAMPER) {
            onChangeQuantityHamper(sku, quantity);
        } else {
            setHamperItemQuantity(hamperItemKey, quantity, sku);
        }
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_teko_ecommerce__WEBPACK_IMPORTED_MODULE_5__/* .ProductCard */ .I, _objectSpreadProps(_objectSpread({}, rest), {
        customButtons: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
            direction: isMobile ? "column" : "row",
            width: "100%",
            align: "center",
            children: [
                hamperCardType === EHamperCardType.HAMPER && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                    width: isMobile ? "100%" : "50%",
                    children: isMobile ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                        variant: "secondary",
                        size: "s",
                        block: true,
                        onClick: ()=>{
                            return onUpdateConfig === null || onUpdateConfig === void 0 ? void 0 : onUpdateConfig(props);
                        },
                        marginBottom: "s12",
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Tuỳ chỉnh")
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_9__/* .Tooltip */ .u, {
                        title: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Thay đổi th\xe0nh phần để tạo giỏ qu\xe0 tự chọn"),
                        placement: "top",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                            variant: "secondary",
                            size: "s",
                            block: true,
                            paddingLeft: "s16",
                            paddingRight: "s16",
                            onClick: ()=>{
                                return onUpdateConfig === null || onUpdateConfig === void 0 ? void 0 : onUpdateConfig(props);
                            },
                            children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Tuỳ chỉnh")
                        })
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_6__/* .Flex */ .k, {
                    width: isMobile || hamperCardType !== EHamperCardType.HAMPER ? "100%" : "50%",
                    children: quantity > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_10__/* .Quantity */ .h, {
                        block: true,
                        quantity: quantity,
                        setQuantity: (newQuantity)=>handleChangeQuantity(props.sku, newQuantity),
                        onMinus: quantity === 1 ? ()=>handleRemove(props.sku) : ()=>handleMinus(props.sku),
                        onPlus: ()=>handleAdd(props.sku),
                        min: 0,
                        max: 999,
                        color: "primary500"
                    }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_7__/* .Button */ .z, {
                        variant: "primary",
                        size: "s",
                        block: true,
                        padding: "s0",
                        onClick: (e)=>{
                            e.preventDefault();
                            handleAdd(props.sku);
                        },
                        children: (0,i18n__WEBPACK_IMPORTED_MODULE_8__.t)("Chọn")
                    })
                })
            ]
        })
    }));
};


/***/ }),

/***/ 774608:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CY": function() { return /* binding */ getKeyFromNode; },
/* harmony export */   "Fb": function() { return /* binding */ getDefaultSortOptions; },
/* harmony export */   "I_": function() { return /* binding */ getCollectionSlug; },
/* harmony export */   "N2": function() { return /* binding */ findChildren; },
/* harmony export */   "N8": function() { return /* binding */ cookCategoryTree; },
/* harmony export */   "Ou": function() { return /* binding */ getDisplayFilter; },
/* harmony export */   "To": function() { return /* binding */ extractSortQuery; },
/* harmony export */   "j3": function() { return /* binding */ getActiveSortOption; },
/* harmony export */   "kr": function() { return /* binding */ cookFilterPrice; },
/* harmony export */   "pt": function() { return /* binding */ omitQuery; },
/* harmony export */   "qh": function() { return /* binding */ convertSubsections; },
/* harmony export */   "tF": function() { return /* binding */ getDataFromKey; },
/* harmony export */   "wi": function() { return /* binding */ findAncestors; },
/* harmony export */   "xP": function() { return /* binding */ getSignatureQueryParam; }
/* harmony export */ });
/* unused harmony exports clearFilterLink, replaceVariablesWithValues */
/* harmony import */ var _teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(19840);
/* harmony import */ var _teko_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(927250);
/* harmony import */ var i18n__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(634655);
/* harmony import */ var types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(189782);
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _objectSpreadProps(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}




/**
 *
 * @param  query
 * @returns
 * remove dynamic params from query
 * - ex: domain.vn/c/abc?slug=abc&page=2 -> domain.vn/c/abc?page=2
 */ const omitQuery = (query)=>{
    const omitKeys = [
        "slug",
        "categoryId",
        "sellerCategoryId",
        "brandId",
        "sellerId", 
    ];
    return (0,_teko_ds_desktop__WEBPACK_IMPORTED_MODULE_0__/* .omit */ .CE)(query, omitKeys);
};
const joinSortQuery = (param)=>{
    let { sort , order  } = param;
    return "".concat(sort).concat(SORT_QUERY_JOIN_CHAR).concat(order);
};
const SORT_QUERY_JOIN_CHAR = "&";
const getDefaultSortOptions = (sortByCreatedAt)=>{
    return [
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Khuyến m\xe3i tốt nhất"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_DISCOUNT_PERCENT",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Gi\xe1 tăng dần"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_PRICE",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.ASC */ .d.ASC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Gi\xe1 giảm dần"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_PRICE",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Sản phẩm mới nhất"),
            optionCode: joinSortQuery({
                sort: !!sortByCreatedAt ? "SORT_BY_CREATED_AT" : "SORT_BY_PUBLISH_AT",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        },
        {
            optionName: (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)("Sản phẩm b\xe1n chạy nhất"),
            optionCode: joinSortQuery({
                sort: "SORT_BY_TOP_SALE_QUANTITY_7_DAYS",
                order: types__WEBPACK_IMPORTED_MODULE_2__/* .OrderBy.DESC */ .d.DESC
            })
        }, 
    ];
};
const extractSortQuery = (joinedQuery)=>{
    return joinedQuery.split(SORT_QUERY_JOIN_CHAR);
};
const getActiveSortOption = (query, sortByCreatedAt, defaultSortOptionCode)=>{
    const defaultSortOption = defaultSortOptionCode ? getDefaultSortOptions(sortByCreatedAt).find((option)=>option.optionCode === (0,i18n__WEBPACK_IMPORTED_MODULE_1__.t)(defaultSortOptionCode)) || null : null;
    const sortOptionFromQuery = getDefaultSortOptions(sortByCreatedAt).find((opt)=>opt.optionCode === joinSortQuery({
            sort: query.sort,
            order: query.order
        }));
    return sortOptionFromQuery !== null && sortOptionFromQuery !== void 0 ? sortOptionFromQuery : defaultSortOption;
};
const clearFilterLink = (rootPath, query)=>{
    return rootPath === "/search" ? "/search?router=productListing".concat(query.query ? "&query=".concat(query.query) : "") : "".concat( true ? window.location.origin : 0).concat(rootPath);
};
const cookFilterPrice = function() {
    let lte = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10000000, gte = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    /**
   * default : gte: 0, lte: 10.000.000, step = 500.000, delta = lte - gte
   * lte: is rounded to 50k, 500K, 1M, 5M
   * step = (delta / 20) is rounded to 5k, 10k, 100K, 500K
   */ lte = lte === null || isNaN(lte) ? 10000000 : lte;
    gte = gte === null || isNaN(gte) ? 0 : gte;
    let priceLte = (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .stringToInteger */ .C)(lte.toString()) || (0,_teko_utils__WEBPACK_IMPORTED_MODULE_3__/* .stringToInteger */ .C)(gte.toString(), 0) + 500000;
    const priceGte = 0;
    if (priceLte < 200000) {
        priceLte = Math.ceil(priceLte / 50000) * 50000;
    }
    if (priceLte > 200000 && priceLte < 500000) {
        priceLte = 500000;
    }
    if (priceLte > 500000 && priceLte < 5000000) {
        priceLte = Math.ceil(priceLte / 1000000) * 1000000;
    }
    if (priceLte > 5000000) {
        priceLte = Math.ceil(priceLte / 5000000) * 5000000;
    }
    const delta = priceLte - priceGte;
    let step = 100000;
    if (delta < 200000) {
        step = Math.ceil(delta / 100000) * 5000;
    /**minStep : 5.000d , maxStep: 10.000 */ }
    if (delta > 200000 && delta <= 2000000) {
        step = Math.ceil(delta / 200000) * 10000;
    /**minStep : 20.000d , maxStep: 100.000 */ }
    if (delta > 2000000 && delta <= 10000000) {
        step = Math.ceil(delta / 2000000) * 100000;
    /**minStep : 100.000d , maxStep: 500.000 */ }
    if (delta > 10000000) {
        step = 500000;
    }
    // steps
    return {
        max: priceLte,
        min: priceGte,
        step: step
    };
};
const getDisplayFilter = (filters)=>{
    return filters.filter((filter)=>{
        var ref;
        return (filter === null || filter === void 0 ? void 0 : (ref = filter.options) === null || ref === void 0 ? void 0 : ref.length) && filter.options.length > 1;
    });
};
const getCollectionSlug = (slug)=>slug ? "/c/".concat(slug) : "";
const getSignatureQueryParam = (query)=>{
    let signatureFilterQueryParams = {};
    const { brandId , sellerId , providerId , sellerCategories , masterCategoryIds , categoryId , sellerCategoryId ,  } = query;
    // handle link like this: /search?router=productListing&sellerCategories=015
    if (sellerCategories) {
        signatureFilterQueryParams = {
            masterCategoryIds: sellerCategories
        };
    } else if (masterCategoryIds) {
        signatureFilterQueryParams = {
            masterCategoryIds: masterCategoryIds
        };
    } else if (providerId) {
        signatureFilterQueryParams = {
            providerIds: [
                providerId
            ]
        };
    } else if (sellerId) {
        signatureFilterQueryParams = {
            sellerIds: [
                sellerId
            ]
        };
    } else if (brandId) {
        signatureFilterQueryParams = {
            brands: typeof brandId === "string" ? [
                brandId
            ] : [
                ...brandId
            ]
        };
    } else if (categoryId) {
        signatureFilterQueryParams = {
            masterCategoryIds: [
                categoryId
            ]
        };
    } else if (sellerCategoryId) {
        signatureFilterQueryParams = {
            categories: [
                sellerCategoryId
            ]
        };
    }
    return signatureFilterQueryParams;
};
/**
 *
 * @param i a number
 * @returns return '01' if i = 1, return '11' if i = 11
 */ const padString = (i)=>i < 10 ? "0" + i : "" + i;
const CURRENT_MONTH_KEY = "%currentMonth%";
const CURRENT_YEAR_KEY = "%currentYear%";
const replaceVariablesWithValues = (date, metaTitle)=>{
    const mapMetaTitleVariables = {
        [CURRENT_MONTH_KEY]: padString(date.getMonth() + 1),
        [CURRENT_YEAR_KEY]: padString(date.getFullYear())
    };
    if (metaTitle) {
        const reg = new RegExp(Object.keys(mapMetaTitleVariables).join("|"), "g");
        return metaTitle.replace(reg, (matched)=>mapMetaTitleVariables[matched]);
    }
    return metaTitle;
};
const cookCategoryTree = (rawCategories)=>{
    if (!(rawCategories === null || rawCategories === void 0 ? void 0 : rawCategories.length)) return {
        cookedCategories: {},
        cookedCategoriesById: new Map(),
        cookedCategoriesByCode: new Map()
    };
    const nodeMap = new Map();
    for (const c of rawCategories){
        nodeMap.set(c.id, _objectSpreadProps(_objectSpread({}, c), {
            children: {}
        }));
    }
    const result = {};
    const nodeById = new Map();
    const nodeByCode = new Map();
    for (const node of nodeMap.values()){
        var _parentId;
        const parentId = (_parentId = node.parentId) !== null && _parentId !== void 0 ? _parentId : 0;
        const parent = parentId ? nodeMap.get(parentId) : undefined;
        if (!parent) {
            result[node.id] = node;
        } else {
            parent.children[node.id] = node;
        }
        nodeById.set(node.id, node);
        nodeByCode.set(node.code, node);
    }
    return {
        cookedCategories: result,
        cookedCategoriesById: nodeById,
        cookedCategoriesByCode: nodeByCode
    };
};
const getKeyFromNode = (node)=>{
    var _parentId;
    return "".concat(node.id, "_").concat((_parentId = node.parentId) !== null && _parentId !== void 0 ? _parentId : 0);
};
const getDataFromKey = (key)=>{
    const [id, parentId] = key.split("_");
    return {
        id: Number(id),
        parentId: Number(parentId)
    };
};
const findChildren = function(node) {
    let skipInitial = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    const keys = [];
    !skipInitial && (node === null || node === void 0 ? void 0 : node.id) && keys.push(getKeyFromNode(node));
    var _children;
    for (const child of Object.values((_children = node.children) !== null && _children !== void 0 ? _children : {})){
        keys.push(...findChildren(child));
    }
    return keys;
};
const findAncestors = function(node, cookedCategoriesById) {
    let skipInitial = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    const ancestorsKeys = [];
    !skipInitial && (node === null || node === void 0 ? void 0 : node.id) && ancestorsKeys.push(getKeyFromNode(node));
    let parentId = node === null || node === void 0 ? void 0 : node.parentId;
    while(parentId){
        const parent = cookedCategoriesById.get(parentId);
        if (!parent) break;
        ancestorsKeys.push(getKeyFromNode(parent));
        parentId = parent.parentId;
    }
    return ancestorsKeys;
};
const convertSubsections = (subsectionsFromWorkload)=>{
    const { brands , others  } = subsectionsFromWorkload;
    const res = [];
    if (!!brands && !!brands.length) {
        res.push({
            type: "IMAGES",
            items: brands.map((brand)=>({
                    linkUrl: brand.url,
                    thumbnailUrl: brand.logo
                }))
        });
    }
    others === null || others === void 0 ? void 0 : others.forEach((other)=>{
        if (!!(other === null || other === void 0 ? void 0 : other.items.length)) {
            res.push({
                type: "IMAGES_AND_TEXT",
                title: other.label,
                items: other.items.map((item)=>({
                        linkUrl: item.url,
                        thumbnailUrl: item.image,
                        description: item.description
                    }))
            });
        }
    });
    return res;
};


/***/ })

}]);